import React, { useState, useEffect } from "react";
import { Table } from "antd";
import axios from "axios";
import qs from "qs";
import { Grid } from "@mui/material";
import { toast } from "react-toastify";

import Swal from "sweetalert2";

// function LoadingModal({ progress }) {
//   return (
//     <div
//       className="loading-modal"
//       style={{
//         display: "flex",
//         background: "rgba(0, 0, 0, 0.7)",
//         backdropFilter: "blur(5px)",
//         position: "fixed",
//         top: 0,
//         left: 0,
//         width: "100%",
//         height: "100%",
//         zIndex: 1050,
//         justifyContent: "center",
//         alignItems: "center",
//         flexDirection: "column",
//       }}
//     >
//       <div
//         className="spinner-border mb-3"
//         role="status"
//         style={{ color: "#fff" }}
//       >
//         <span className="visually-hidden">Loading...</span>
//       </div>
//     </div>
//   );
// }

function LoadingModal({ progress }) {
  return (
    <div
      className="loading-modal"
      style={{
        display: "flex",
        background: "rgba(0, 0, 0, 0.7)",
        backdropFilter: "blur(5px)",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 1050,
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          width: "400px",
          background: "#fff",
          padding: "20px",
          borderRadius: "10px",
          textAlign: "center",
        }}
      >
        <h5>Exporting data...</h5>

        <div
          style={{
            width: "100%",
            height: "10px",
            background: "#eee",
            borderRadius: "10px",
            overflow: "hidden",
            marginTop: "15px",
          }}
        >
          <div
            style={{
              width: `${progress}%`,
              height: "100%",
              background: "#28a745",
              transition: "width 0.3s ease",
            }}
          />
        </div>

        <div style={{ marginTop: "10px", fontWeight: 600 }}>{progress}%</div>
      </div>
    </div>
  );
}

const Whatsapp_Campaign = () => {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);

  const [loading, setLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [selectedDate, setSelectedDate] = useState("");
  const formattedDate = selectedDate
    ? selectedDate.split("-").reverse().join("-")
    : "";

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
    },
  });

  const [numRecords, setNumRecords] = useState("");
  const [batch, setBatch] = useState("");
  const [startDate, setStartDate] = useState(""); // Add state for start date
  const [endDate, setEndDate] = useState(""); // Add state for end date

  const fetchContactData = async () => {
    setLoading(true);
    try {
      const params = {
        startreq:
          (tableParams.pagination.current - 1) *
          tableParams.pagination.pageSize,
        limit: tableParams.pagination.pageSize,
      };

      const response = await axios.get(
        `/api/whatsappcampaign/getcontactsforwhatsappcampaign?${qs.stringify(
          params,
        )}`,
      );
      setData(response.data.contacts);
      setTotal(response.data.totalCount);
    } catch (error) {
      console.error("Error fetching contact data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContactData();
  }, [JSON.stringify(tableParams)]);

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });
  };

  const handleDownload = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to download all contacts.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, download it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setDownloadLoading(true);
        axios
          .get("/api/whatsappcampaign/download", { responseType: "blob" })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "contacts.zip");
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            toast.success("File downloaded successfully!");
          })
          .catch((error) => {
            console.error("Error downloading the file:", error);
            toast.error("Error downloading the file.");
          })
          .finally(() => setDownloadLoading(false));
      }
    });
  };

  const handleRandomDownload = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You are about to download ${numRecords} records in batches of ${batch} with a ${selectedOption}: ${inputValue}.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, download it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setDownloadLoading(true);
        const batchTag = `${selectedOption}: ${inputValue}`; // Combine the selected option and input value for the batch tag
        console.log("Batch Tag (lowercase):", batchTag);
        axios
          .get(
            `/api/whatsappcampaign/random?numRecords=${numRecords}&batch=${batch}&batchTag=${batchTag}`, // Add batchTag as a parameter
            {
              responseType: "json", // Expect JSON response
            },
          )
          .then((response) => {
            console.log("Response from API:", response.data);
            const { csvFile, contactIds } = response.data;

            if (contactIds && contactIds.length > 0) {
              // Create a download link for the CSV file
              const url = window.URL.createObjectURL(new Blob([csvFile]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "randomcontacts.csv");
              document.body.appendChild(link);
              link.click();
              link.parentNode.removeChild(link);

              // Prompt to update DTMF campaign
              Swal.fire({
                title: "Update Whatsapp Campaign?",
                text: "Do you want to update the Whatsapp campaign for the downloaded data?",
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, update it!",
              }).then((updateResult) => {
                if (updateResult.isConfirmed) {
                  axios
                    .post("/api/whatsappcampaign/updatedtmf", { contactIds })
                    .then(() => {
                      toast.success("Contacts updated successfully!");
                      fetchContactData(); // Refresh data if needed
                    })
                    .catch((error) => {
                      console.error("Error updating contacts:", error);
                      toast.error("Error updating contacts.");
                    });
                }
              });
            } else {
              console.error("No contact IDs found in the response.");
              toast.error("No contact IDs found.");
            }
          })
          .catch((error) => {
            console.error("Error downloading the file:", error);
            toast.error("Error downloading the random contacts.");
          })
          .finally(() => setDownloadLoading(false));
      }
    });
  };

  const handleFilterDownload = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You are about to download ${startDate}.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, download it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setDownloadLoading(true);
        axios
          .get(`/api/whatsappcampaign/date`, {
            responseType: "json", // Expect JSON response
            params: { startDate, endDate },
          })
          .then((response) => {
            console.log("Response from API:", response.data);
            const { csvFile, contactIds } = response.data;

            if (contactIds && contactIds.length > 0) {
              // Create a download link for the CSV file
              const url = window.URL.createObjectURL(new Blob([csvFile]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "datewise_contacts.csv");
              document.body.appendChild(link);
              link.click();
              link.parentNode.removeChild(link);

              // Prompt to update DTMF campaign
              Swal.fire({
                title: "Update Whatsapp Campaign?",
                text: "Do you want to update the Whatsapp campaign for the downloaded data?",
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, update it!",
              }).then((updateResult) => {
                if (updateResult.isConfirmed) {
                  axios
                    .post("/api/whatsappcampaign/updatedtmf1", { contactIds })
                    .then(() => {
                      toast.success("Contacts updated successfully!");
                      fetchContactData(); // Refresh data if needed
                    })
                    .catch((error) => {
                      const errorMessage =
                        error.response?.data?.message ||
                        "Error updating contacts.";
                      console.error("Error updating contacts:", errorMessage);
                      toast.error(errorMessage);
                    });
                }
              });
            } else {
              console.error("No contact IDs found in the response.");
              toast.error("No contact IDs found.");
            }
          })
          .catch((error) => {
            const errorMessage =
              error.response?.data?.message ||
              "Error downloading the datewise contacts.";
            console.error("Error downloading the file:", errorMessage);
            toast.error(errorMessage);
          })
          .finally(() => setDownloadLoading(false));
      }
    });
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      ellipsis: true,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      ellipsis: true,
    },
    {
      title: "Phone",
      dataIndex: "mobile",
      key: "mobile",
      ellipsis: true,
    },
  ];

  const [selectedOption, setSelectedOption] = useState("Prefix"); // Tracks the selected dropdown option
  const [inputValue, setInputValue] = useState(""); // Tracks input field value

  // Handle dropdown selection
  const handleDropdownSelection = (value) => {
    setSelectedOption(value);
    setInputValue(""); // Reset input value when option changes
  };
  // Function to handle the input box value change
  const handleInputChange = (e) => {
    setInputValue(e.target.value); // Update the input value based on user input
    console.log("Input value for", selectedOption, ":", e.target.value); // Log the input value
  };

  const getDataSource = () => {
    return data;
  };

  const handleNumRecordsChange = (e) => {
    setNumRecords(e.target.value);
  };

  const handleBatchChange = (e) => {
    setBatch(e.target.value);
  };

  const handleStartDateChange = (event) => {
    const newStartDate = event.target.value;
    setStartDate(newStartDate);
    setEndDate(newStartDate); // Automatically set endDate to match startDate
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };

  const handleModalButton = () => {
    setStartDate("");
    setEndDate("");
    setInputValue("");
    setSelectedOption("Prefix");
    setNumRecords("");
    setBatch("");
    setSelectedDate("");
  };

  // const handleExportToGoogleSheet = async () => {
  //   Swal.fire({
  //     title: "Are you sure?",
  //     text: `You are about to download ${numRecords} records in batches of ${batch} with a ${selectedOption}: ${inputValue}.`,
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "Yes, download it!",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       setDownloadLoading(true);
  //       setDownloadProgress(10);

  //       const batchTag = `${selectedOption}: ${inputValue}`;

  //       axios
  //         .get(
  //           `/api/whatsappcampaign/export-google-sheet?numRecords=${numRecords}&batch=${batch}&batchTag=${batchTag}&datetime=${formattedDate}`,
  //         )
  //         .then((response) => {
  //           console.log("Response from API:", response.data);

  //           const { contactIds } = response.data;

  //           // ✅ Google sheet success
  //           toast.success("Data exported to Google Sheet successfully!");

  //           // Optional update prompt
  //           if (contactIds && contactIds.length > 0) {
  //             Swal.fire({
  //               title: "Update Whatsapp Campaign?",
  //               text: "Do you want to update the Whatsapp campaign for the exported data?",
  //               icon: "question",
  //               showCancelButton: true,
  //               confirmButtonColor: "#3085d6",
  //               cancelButtonColor: "#d33",
  //               confirmButtonText: "Yes, update it!",
  //             }).then((updateResult) => {
  //               if (updateResult.isConfirmed) {
  //                 axios
  //                   .post("/api/whatsappcampaign/updatedtmf", { contactIds })
  //                   .then(() => {
  //                     toast.success("Contacts updated successfully!");
  //                     fetchContactData();
  //                   })
  //                   .catch((error) => {
  //                     console.error("Error updating contacts:", error);
  //                     toast.error("Error updating contacts.");
  //                   });
  //               }
  //             });
  //           }
  //         })
  //         .catch((error) => {
  //           console.error("Error exporting to Google sheet:", error);
  //           toast.error(
  //             error.response?.data?.error || "Error exporting to Google sheet.",
  //           );
  //         })
  //         .finally(() => setDownloadLoading(false));
  //     }
  //   });
  // };

  const handleExportToGoogleSheet = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You are about to download ${numRecords} records in batches of ${batch} with a ${selectedOption}: ${inputValue}.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, download it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setDownloadLoading(true);
        setDownloadProgress(0);

        // ✅ smooth progress animation
        let progress = 0;
        const interval = setInterval(() => {
          progress += Math.random() * 12;

          if (progress >= 90) {
            progress = 90;
            clearInterval(interval);
          }

          setDownloadProgress(Math.floor(progress));
        }, 400);

        const batchTag = `${selectedOption}: ${inputValue}`;

        axios
          .get(
            `/api/whatsappcampaign/export-google-sheet?numRecords=${numRecords}&batch=${batch}&batchTag=${batchTag}&datetime=${formattedDate}`,
          )
          .then((response) => {
            clearInterval(interval);
            setDownloadProgress(100);

            console.log("Response from API:", response.data);

            const { contactIds } = response.data;

            // ✅ Google sheet success
            toast.success("Data exported to Google Sheet successfully!");

            // Optional update prompt
            if (contactIds && contactIds.length > 0) {
              Swal.fire({
                title: "Update Whatsapp Campaign?",
                text: "Do you want to update the Whatsapp campaign for the exported data?",
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, update it!",
              }).then((updateResult) => {
                if (updateResult.isConfirmed) {
                  axios
                    .post("/api/whatsappcampaign/updatedtmf", { contactIds })
                    .then(() => {
                      toast.success("Contacts updated successfully!");
                      fetchContactData();
                    })
                    .catch((error) => {
                      console.error("Error updating contacts:", error);
                      toast.error("Error updating contacts.");
                    });
                }
              });
            }
          })
          .catch((error) => {
            clearInterval(interval);

            console.error("Error exporting to Google sheet:", error);
            toast.error(
              error.response?.data?.error || "Error exporting to Google sheet.",
            );
          })
          .finally(() => {
            setTimeout(() => {
              setDownloadLoading(false);
              setDownloadProgress(0);
            }, 500);
          });
      }
    });
  };

  return (
    <div className="page-content w-100">
      <div className="container">
        {downloadLoading && <LoadingModal progress={downloadProgress} />}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 className="mb-sm-0 py-3">Whatsapp Campaign</h4>
              <div>
                <h4 className="mb-sm-0 py-3" style={{ color: "#EE0C5D" }}>
                  Fresh Data : {total}
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xxl-12">
            <div id="contactList" className="card">
              <div className="card-header py-3">
                <div className="d-flex align-items-center flex-wrap gap-2">
                  <div className="d-flex flex-wrap flex-grow-1 gap-2"></div>
                  <div className="flex-shrink-0">
                    <button
                      type="button"
                      className="btn btn-warning add-btn"
                      data-bs-toggle="modal"
                      data-bs-target="#exportToGoogleSheetModal"
                      onClick={handleModalButton}
                    >
                      <i className="ri-add-fill me-1 align-bottom"></i> Export
                      To Google Sheet
                    </button>
                  </div>
                  <div className="flex-shrink-0">
                    <button
                      type="button"
                      className="btn btn-danger add-btn"
                      data-bs-toggle="modal"
                      data-bs-target="#filterModal"
                      onClick={handleModalButton}
                    >
                      <i className="ri-add-fill me-1 align-bottom"></i> Filter
                    </button>
                  </div>

                  <div className="flex-shrink-0">
                    <button
                      type="button"
                      className="btn btn-primary add-btn"
                      data-bs-toggle="modal"
                      data-bs-target="#exportModal"
                      onClick={handleModalButton}
                    >
                      <i className="ri-add-fill me-1 align-bottom"></i> Export
                      Data
                    </button>
                  </div>
                  <div className="flex-shrink-0">
                    <button
                      type="primary"
                      className="btn btn-success"
                      onClick={handleDownload}
                    >
                      Download All
                    </button>
                  </div>

                  {/* Export To Google Sheet Modal */}
                  <div
                    className="modal fade"
                    id="exportToGoogleSheetModal"
                    tabIndex="-1"
                    aria-labelledby="exportToGoogleSheetModalLabel"
                  >
                    <div className="modal-dialog">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5
                            className="modal-title"
                            id="exportToGoogleSheetModalLabel"
                          >
                            Export Data
                          </h5>
                          <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          ></button>
                        </div>
                        <div className="modal-body">
                          <Grid
                            container
                            spacing={1}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Grid item xs={6}>
                              <div>
                                <label htmlFor="randomcount">No. of Data</label>
                                <select
                                  className="form-select mt-2"
                                  name="randomcount"
                                  id="randomcount"
                                  value={numRecords}
                                  onChange={handleNumRecordsChange}
                                >
                                  <option value="...">...</option>

                                  <option value="10">10</option>
                                  <option value="20">20</option>
                                  <option value="30">30</option>
                                  <option value="40">40</option>
                                  <option value="50">50</option>
                                  <option value="100">100</option>
                                  <option value="1000">1K</option>
                                  <option value="2000">2K</option>
                                  <option value="5000">5K</option>
                                  <option value="8000">8K</option>
                                  <option value="10000">10K</option>
                                  <option value="20000">20K</option>
                                  <option value="30000">30K</option>
                                  <option value="40000">40K</option>
                                  <option value="50000">50K</option>
                                  {/* <option value="100000">1 Lac</option> */}
                                </select>
                              </div>
                            </Grid>
                            <Grid item xs={6}>
                              <div>
                                <label htmlFor="batch">Batch</label>
                                <select
                                  className="form-select mt-2"
                                  name="batch"
                                  id="batch"
                                  value={batch}
                                  onChange={handleBatchChange}
                                >
                                  <option value="...">...</option>
                                  <option value="5">5</option>
                                  <option value="10">10</option>
                                  <option value="20">20</option>
                                  <option value="30">30</option>
                                  <option value="40">40</option>
                                  <option value="50">50</option>
                                  <option value="500">500</option>
                                  <option value="1000">1000</option>
                                  <option value="2000">2000</option>
                                  <option value="5000">5000</option>
                                  <option value="10000">10000</option>
                                </select>
                              </div>
                            </Grid>
                          </Grid>
                          <Grid
                            container
                            spacing={1}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginTop: "10px",
                            }}
                          >
                            <Grid item xs={12}>
                              <div>
                                <label htmlFor="batch">Batch Tag</label>
                                <form action="" className="d-flex gap-3 mt-2">
                                  <div
                                    class="input-group"
                                    style={{ width: "100%" }}
                                  >
                                    <button
                                      class="btn btn-outline-secondary dropdown-toggle"
                                      type="button"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                      style={{ width: "30%" }}
                                    >
                                      {selectedOption}
                                      {/* Show selected option */}
                                    </button>
                                    <ul class="dropdown-menu">
                                      <li>
                                        <a
                                          className={`dropdown-item ${
                                            selectedOption === "Prefix"
                                              ? "active"
                                              : ""
                                          }`} // Highlight active choice
                                          href="#"
                                          onClick={() =>
                                            handleDropdownSelection("Prefix")
                                          }
                                        >
                                          Prefix
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          className={`dropdown-item ${
                                            selectedOption === "Suffix"
                                              ? "active"
                                              : ""
                                          }`} // Highlight active choice
                                          href="#"
                                          onClick={() =>
                                            handleDropdownSelection("Suffix")
                                          }
                                        >
                                          Suffix
                                        </a>
                                      </li>
                                    </ul>
                                    <input
                                      type="text"
                                      name={selectedOption} // Dynamically set name based on option
                                      value={inputValue} // Set value of the input
                                      onChange={handleInputChange} // Handle change
                                      class="form-control"
                                      aria-label="Text input with dropdown button"
                                      style={{ width: "60%" }}
                                    />
                                  </div>
                                </form>
                              </div>
                            </Grid>
                          </Grid>
                          {/* <Grid item xs={4} className="mt-3">
                            <label htmlFor="datetime">
                              Date & Time
                            </label>
                            <input
                              type="datetime-local"
                              id="datetime"
                              name="datetime"
                              className="form-select w-100 mt-2"
                            />
                          </Grid> */}
                          <Grid item xs={12}>
                            <div
                              className="p-3 bg-white rounded-3 shadow-sm border"
                              style={{ borderColor: "#e5e7eb" }}
                            >
                              <label className="fw-semibold text-muted">
                                SheetDate
                              </label>
                              <input
                                type="date"
                                className="form-control mt-2 rounded-3"
                                value={selectedDate}
                                onChange={(e) =>
                                  setSelectedDate(e.target.value)
                                }
                              />
                            </div>
                          </Grid>
                        </div>
                        <div className="modal-footer">
                          <button
                            onClick={handleExportToGoogleSheet}
                            type="button"
                            className="btn btn-primary"
                            data-bs-dismiss="modal"
                          >
                            Download
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Filter Modal */}
                  <div
                    className="modal fade"
                    id="filterModal"
                    tabIndex="-1"
                    aria-labelledby="filterModalLabel"
                  >
                    <div className="modal-dialog">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title" id="filterModalLabel">
                            Filter Modal
                          </h5>
                          <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          ></button>
                        </div>
                        <div className="modal-body">
                          <Grid
                            container
                            spacing={1}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Grid item xs={6}>
                              <div>
                                <label htmlFor="startDate">From</label>
                                <input
                                  type="date"
                                  className="form-control"
                                  value={startDate}
                                  onChange={handleStartDateChange}
                                />
                              </div>
                            </Grid>
                            <Grid item xs={6}>
                              {/* <div>
                                <label htmlFor="endDate">To</label>
                                <input
                                  type="date"
                                  className="form-control"
                                  value={endDate}
                                  // onChange={handleEndDateChange}
                                />
                              </div> */}
                            </Grid>
                          </Grid>
                        </div>
                        <div className="modal-footer">
                          <button
                            onClick={handleFilterDownload}
                            type="button"
                            className="btn btn-primary"
                            data-bs-dismiss="modal"
                          >
                            Download
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Export Random Data Modal */}
                  <div
                    className="modal fade"
                    id="exportModal"
                    tabIndex="-1"
                    aria-labelledby="exportModalLabel"
                  >
                    <div className="modal-dialog">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title" id="exportModalLabel">
                            Export Data
                          </h5>
                          <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          ></button>
                        </div>
                        <div className="modal-body">
                          <Grid
                            container
                            spacing={1}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Grid item xs={6}>
                              <div>
                                <label htmlFor="randomcount">No. of Data</label>
                                <select
                                  className="form-select mt-2"
                                  name="randomcount"
                                  id="randomcount"
                                  value={numRecords}
                                  onChange={handleNumRecordsChange}
                                >
                                  <option value="...">...</option>

                                  <option value="10">10</option>
                                  <option value="20">20</option>
                                  <option value="30">30</option>
                                  <option value="40">40</option>
                                  <option value="50">50</option>
                                  <option value="100">100</option>
                                  <option value="1000">1K</option>
                                  <option value="2000">2K</option>
                                  <option value="5000">5K</option>
                                  <option value="8000">8K</option>
                                  <option value="10000">10K</option>
                                  <option value="20000">20K</option>
                                  <option value="30000">30K</option>
                                  <option value="40000">40K</option>
                                  <option value="50000">50K</option>
                                  <option value="100000">1 Lac</option>
                                </select>
                              </div>
                            </Grid>
                            <Grid item xs={6}>
                              <div>
                                <label htmlFor="batch">Batch</label>
                                <select
                                  className="form-select mt-2"
                                  name="batch"
                                  id="batch"
                                  value={batch}
                                  onChange={handleBatchChange}
                                >
                                  <option value="...">...</option>
                                  <option value="5">5</option>
                                  <option value="10">10</option>
                                  <option value="20">20</option>
                                  <option value="30">30</option>
                                  <option value="40">40</option>
                                  <option value="50">50</option>
                                  <option value="500">500</option>
                                  <option value="1000">1000</option>
                                  <option value="2000">2000</option>
                                  <option value="5000">5000</option>
                                  <option value="10000">10000</option>
                                </select>
                              </div>
                            </Grid>
                          </Grid>
                          <Grid
                            container
                            spacing={1}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginTop: "10px",
                            }}
                          >
                            <Grid item xs={12}>
                              <div>
                                <label htmlFor="batch">Batch Tag</label>
                                <form action="" className="d-flex gap-3 mt-2">
                                  <div
                                    class="input-group"
                                    style={{ width: "100%" }}
                                  >
                                    <button
                                      class="btn btn-outline-secondary dropdown-toggle"
                                      type="button"
                                      data-bs-toggle="dropdown"
                                      aria-expanded="false"
                                      style={{ width: "30%" }}
                                    >
                                      {selectedOption}
                                      {/* Show selected option */}
                                    </button>
                                    <ul class="dropdown-menu">
                                      <li>
                                        <a
                                          className={`dropdown-item ${
                                            selectedOption === "Prefix"
                                              ? "active"
                                              : ""
                                          }`} // Highlight active choice
                                          href="#"
                                          onClick={() =>
                                            handleDropdownSelection("Prefix")
                                          }
                                        >
                                          Prefix
                                        </a>
                                      </li>
                                      <li>
                                        <a
                                          className={`dropdown-item ${
                                            selectedOption === "Suffix"
                                              ? "active"
                                              : ""
                                          }`} // Highlight active choice
                                          href="#"
                                          onClick={() =>
                                            handleDropdownSelection("Suffix")
                                          }
                                        >
                                          Suffix
                                        </a>
                                      </li>
                                    </ul>
                                    <input
                                      type="text"
                                      name={selectedOption} // Dynamically set name based on option
                                      value={inputValue} // Set value of the input
                                      onChange={handleInputChange} // Handle change
                                      class="form-control"
                                      aria-label="Text input with dropdown button"
                                      style={{ width: "60%" }}
                                    />
                                  </div>
                                </form>
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                        <div className="modal-footer">
                          <button
                            onClick={handleRandomDownload}
                            type="button"
                            className="btn btn-primary"
                            data-bs-dismiss="modal"
                          >
                            Download
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <Table
                  dataSource={getDataSource()}
                  columns={columns}
                  rowKey="_id"
                  pagination={{
                    ...tableParams.pagination,
                    total,
                    position: "bottomRight",
                    showSizeChanger: true,
                    pageSizeOptions: ["10", "15", "20", "50", "100"],
                  }}
                  onChange={handleTableChange}
                  loading={loading}
                  bordered
                  components={{
                    header: {
                      cell: ({ style, ...restProps }) => (
                        <th
                          {...restProps}
                          style={{
                            ...style,
                            backgroundColor: "#c6c6c6",
                            color: "black",
                            textAlign: "center",
                          }}
                        />
                      ),
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Whatsapp_Campaign;
